/**
 * @generated SignedSource<<52f8fde0d941f0ad792e87f27af9056b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperience_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FormatRulesNew_project">;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperience_project";
};
export type ConditionalFormattingSidebarExperience_project$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperience_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperience_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "kind": "FragmentSpread",
      "name": "FormatRulesNew_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "593c92aafec766a50bb7c1dd5b691e8f";

export default node;
